import React, { useState } from 'react';
import { FaArrowLeft, FaCheck, FaUser, FaBriefcase, FaVenusMars, FaUsers, FaHeart } from 'react-icons/fa';
import { toast } from 'react-toastify';

const FamilyInformation = ({ formData, onSubmit, onPrevious, loading, userId }) => {
    const [localData, setLocalData] = useState({
        father: formData.father || '',
        father_occupation: formData.father_occupation || '',
        mother: formData.mother || '',
        mother_occupation: formData.mother_occupation || '',
        unmarride_sister: formData.unmarride_sister || '',
        marride_sister: formData.marride_sister || '',
        unmarride_brother: formData.unmarride_brother || '',
        marride_brother: formData.marride_brother || ''
    });
    
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        // Ensure number fields don't go negative
        if (name.includes('sister') || name.includes('brother')) {
            const numValue = parseInt(value);
            if (value && (numValue < 0 || isNaN(numValue))) {
                return;
            }
        }
        
        setLocalData({ ...localData, [name]: value });
        
        // Mark field as touched
        setTouched({ ...touched, [name]: true });
        
        // Clear error for this field
        if (errors[name]) {
            setErrors({ ...errors, [name]: null });
        }
    };

    const handleBlur = (e) => {
        const { name } = e.target;
        setTouched({ ...touched, [name]: true });
        validateField(name, localData[name]);
    };

    const validateField = (fieldName, value) => {
        let error = '';
        
        switch (fieldName) {
            case 'father':
                if (!value || value.trim() === '') {
                    error = "Father's name is required";
                } else if (value.length < 2) {
                    error = "Father's name must be at least 2 characters";
                } else if (value.length > 100) {
                    error = "Father's name must be less than 100 characters";
                } else if (/[^a-zA-Z\s\-\.]/.test(value)) {
                    error = 'Only letters, spaces, hyphens, and dots are allowed';
                }
                break;
            case 'father_occupation':
                if (!value || value.trim() === '') {
                    error = "Father's occupation is required";
                } else if (value.length < 2) {
                    error = "Father's occupation must be at least 2 characters";
                } else if (value.length > 100) {
                    error = "Father's occupation must be less than 100 characters";
                }
                break;
            case 'mother':
                if (!value || value.trim() === '') {
                    error = "Mother's name is required";
                } else if (value.length < 2) {
                    error = "Mother's name must be at least 2 characters";
                } else if (value.length > 100) {
                    error = "Mother's name must be less than 100 characters";
                } else if (/[^a-zA-Z\s\-\.]/.test(value)) {
                    error = 'Only letters, spaces, hyphens, and dots are allowed';
                }
                break;
            case 'mother_occupation':
                if (!value || value.trim() === '') {
                    error = "Mother's occupation is required";
                } else if (value.length < 2) {
                    error = "Mother's occupation must be at least 2 characters";
                } else if (value.length > 100) {
                    error = "Mother's occupation must be less than 100 characters";
                }
                break;
            case 'unmarride_sister':
                if (value === '' || value === null || value === undefined) {
                    error = 'Number of unmarried sisters is required';
                } else if (parseInt(value) < 0) {
                    error = 'Value cannot be negative';
                } else if (isNaN(parseInt(value))) {
                    error = 'Please enter a valid number';
                }
                break;
            case 'marride_sister':
                if (value === '' || value === null || value === undefined) {
                    error = 'Number of married sisters is required';
                } else if (parseInt(value) < 0) {
                    error = 'Value cannot be negative';
                } else if (isNaN(parseInt(value))) {
                    error = 'Please enter a valid number';
                }
                break;
            case 'unmarride_brother':
                if (value === '' || value === null || value === undefined) {
                    error = 'Number of unmarried brothers is required';
                } else if (parseInt(value) < 0) {
                    error = 'Value cannot be negative';
                } else if (isNaN(parseInt(value))) {
                    error = 'Please enter a valid number';
                }
                break;
            case 'marride_brother':
                if (value === '' || value === null || value === undefined) {
                    error = 'Number of married brothers is required';
                } else if (parseInt(value) < 0) {
                    error = 'Value cannot be negative';
                } else if (isNaN(parseInt(value))) {
                    error = 'Please enter a valid number';
                }
                break;
            default:
                break;
        }
        
        setErrors(prev => ({ ...prev, [fieldName]: error }));
        return error === '';
    };

    const validateForm = () => {
        const fieldsToValidate = [
            'father', 'father_occupation', 'mother', 'mother_occupation',
            'unmarride_sister', 'marride_sister', 'unmarride_brother', 'marride_brother'
        ];
        
        let isValid = true;
        const newErrors = {};
        
        fieldsToValidate.forEach(field => {
            const value = localData[field];
            let error = '';
            
            switch (field) {
                case 'father':
                    if (!value || value.trim() === '') {
                        error = "Father's name is required";
                    } else if (value.length < 2) {
                        error = "Father's name must be at least 2 characters";
                    } else if (value.length > 100) {
                        error = "Father's name must be less than 100 characters";
                    } else if (/[^a-zA-Z\s\-\.]/.test(value)) {
                        error = 'Only letters, spaces, hyphens, and dots are allowed';
                    }
                    break;
                case 'father_occupation':
                    if (!value || value.trim() === '') {
                        error = "Father's occupation is required";
                    } else if (value.length < 2) {
                        error = "Father's occupation must be at least 2 characters";
                    } else if (value.length > 100) {
                        error = "Father's occupation must be less than 100 characters";
                    }
                    break;
                case 'mother':
                    if (!value || value.trim() === '') {
                        error = "Mother's name is required";
                    } else if (value.length < 2) {
                        error = "Mother's name must be at least 2 characters";
                    } else if (value.length > 100) {
                        error = "Mother's name must be less than 100 characters";
                    } else if (/[^a-zA-Z\s\-\.]/.test(value)) {
                        error = 'Only letters, spaces, hyphens, and dots are allowed';
                    }
                    break;
                case 'mother_occupation':
                    if (!value || value.trim() === '') {
                        error = "Mother's occupation is required";
                    } else if (value.length < 2) {
                        error = "Mother's occupation must be at least 2 characters";
                    } else if (value.length > 100) {
                        error = "Mother's occupation must be less than 100 characters";
                    }
                    break;
                case 'unmarride_sister':
                    if (value === '' || value === null || value === undefined) {
                        error = 'Number of unmarried sisters is required';
                    } else if (parseInt(value) < 0) {
                        error = 'Value cannot be negative';
                    } else if (isNaN(parseInt(value))) {
                        error = 'Please enter a valid number';
                    }
                    break;
                case 'marride_sister':
                    if (value === '' || value === null || value === undefined) {
                        error = 'Number of married sisters is required';
                    } else if (parseInt(value) < 0) {
                        error = 'Value cannot be negative';
                    } else if (isNaN(parseInt(value))) {
                        error = 'Please enter a valid number';
                    }
                    break;
                case 'unmarride_brother':
                    if (value === '' || value === null || value === undefined) {
                        error = 'Number of unmarried brothers is required';
                    } else if (parseInt(value) < 0) {
                        error = 'Value cannot be negative';
                    } else if (isNaN(parseInt(value))) {
                        error = 'Please enter a valid number';
                    }
                    break;
                case 'marride_brother':
                    if (value === '' || value === null || value === undefined) {
                        error = 'Number of married brothers is required';
                    } else if (parseInt(value) < 0) {
                        error = 'Value cannot be negative';
                    } else if (isNaN(parseInt(value))) {
                        error = 'Please enter a valid number';
                    }
                    break;
                default:
                    break;
            }
            
            if (error) {
                isValid = false;
                newErrors[field] = error;
            }
        });
        
        setErrors(newErrors);
        
        // Mark all fields as touched
        const allTouched = {};
        fieldsToValidate.forEach(field => {
            allTouched[field] = true;
        });
        setTouched(allTouched);
        
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const submissionData = {
                user_id: userId,
                father: localData.father || '',
                father_occupation: localData.father_occupation || '',
                mother: localData.mother || '',
                mother_occupation: localData.mother_occupation || '',
                unmarride_sister: localData.unmarride_sister || 0,
                marride_sister: localData.marride_sister || 0,
                unmarride_brother: localData.unmarride_brother || 0,
                marride_brother: localData.marride_brother || 0
            };
            
            console.log('Submitting family data:', submissionData);
            onSubmit(submissionData);
        } else {
            toast.error('Please fill all required fields correctly');
        }
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            <div className="flex items-center space-x-2 mb-6">
                <FaUsers className="text-indigo-600 text-xl" />
                <h2 className="text-2xl font-bold text-gray-800">Family Information</h2>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Father's Name */}
                <div>
                    <label className="form-label">
                        <FaUser className="inline mr-2" />
                        Father's Name <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        name="father"
                        value={localData.father}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-input ${errors.father && touched.father ? 'input-error' : ''}`}
                        placeholder="Enter father's name"
                    />
                    {errors.father && touched.father && <p className="error-message">{errors.father}</p>}
                </div>
                
                {/* Father's Occupation - Text Input */}
                <div>
                    <label className="form-label">
                        <FaBriefcase className="inline mr-2" />
                        Father's Occupation <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        name="father_occupation"
                        value={localData.father_occupation}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-input ${errors.father_occupation && touched.father_occupation ? 'input-error' : ''}`}
                        placeholder="Enter father's occupation (e.g., Farmer, Teacher, Business)"
                    />
                    {errors.father_occupation && touched.father_occupation && <p className="error-message">{errors.father_occupation}</p>}
                    <p className="text-xs text-gray-500 mt-1">Enter father's occupation</p>
                </div>
                
                {/* Mother's Name */}
                <div>
                    <label className="form-label">
                        <FaUser className="inline mr-2" />
                        Mother's Name <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        name="mother"
                        value={localData.mother}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-input ${errors.mother && touched.mother ? 'input-error' : ''}`}
                        placeholder="Enter mother's name"
                    />
                    {errors.mother && touched.mother && <p className="error-message">{errors.mother}</p>}
                </div>
                
                {/* Mother's Occupation - Text Input */}
                <div>
                    <label className="form-label">
                        <FaBriefcase className="inline mr-2" />
                        Mother's Occupation <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        name="mother_occupation"
                        value={localData.mother_occupation}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-input ${errors.mother_occupation && touched.mother_occupation ? 'input-error' : ''}`}
                        placeholder="Enter mother's occupation (e.g., Housewife, Teacher, Business)"
                    />
                    {errors.mother_occupation && touched.mother_occupation && <p className="error-message">{errors.mother_occupation}</p>}
                    <p className="text-xs text-gray-500 mt-1">Enter mother's occupation</p>
                </div>
                
                {/* Unmarried Sisters */}
                <div>
                    <label className="form-label">
                        <FaVenusMars className="inline mr-2" />
                        No. of Unmarried Sisters <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="number"
                        name="unmarride_sister"
                        value={localData.unmarride_sister}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        min="0"
                        className={`form-input ${errors.unmarride_sister && touched.unmarride_sister ? 'input-error' : ''}`}
                        placeholder="0"
                    />
                    {errors.unmarride_sister && touched.unmarride_sister && <p className="error-message">{errors.unmarride_sister}</p>}
                </div>
                
                {/* Married Sisters */}
                <div>
                    <label className="form-label">
                        <FaVenusMars className="inline mr-2" />
                        No. of Married Sisters <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="number"
                        name="marride_sister"
                        value={localData.marride_sister}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        min="0"
                        className={`form-input ${errors.marride_sister && touched.marride_sister ? 'input-error' : ''}`}
                        placeholder="0"
                    />
                    {errors.marride_sister && touched.marride_sister && <p className="error-message">{errors.marride_sister}</p>}
                </div>
                
                {/* Unmarried Brothers */}
                <div>
                    <label className="form-label">
                        <FaVenusMars className="inline mr-2" />
                        No. of Unmarried Brothers <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="number"
                        name="unmarride_brother"
                        value={localData.unmarride_brother}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        min="0"
                        className={`form-input ${errors.unmarride_brother && touched.unmarride_brother ? 'input-error' : ''}`}
                        placeholder="0"
                    />
                    {errors.unmarride_brother && touched.unmarride_brother && <p className="error-message">{errors.unmarride_brother}</p>}
                </div>
                
                {/* Married Brothers */}
                <div>
                    <label className="form-label">
                        <FaVenusMars className="inline mr-2" />
                        No. of Married Brothers <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="number"
                        name="marride_brother"
                        value={localData.marride_brother}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        min="0"
                        className={`form-input ${errors.marride_brother && touched.marride_brother ? 'input-error' : ''}`}
                        placeholder="0"
                    />
                    {errors.marride_brother && touched.marride_brother && <p className="error-message">{errors.marride_brother}</p>}
                </div>
            </div>
            
            {/* Registration Summary */}
            <div className="mt-8 p-6 bg-gradient-to-r from-indigo-50 to-blue-50 rounded-xl border border-indigo-100">
                <h3 className="font-bold text-lg text-gray-800 mb-4 flex items-center">
                    <FaCheck className="text-green-600 mr-2" />
                    Registration Summary
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 text-sm">
                    <div className="space-y-2">
                        <p><strong>Name:</strong> {formData.name || 'Not provided'}</p>
                        <p><strong>DOB:</strong> {formData.dob || 'Not provided'}</p>
                    </div>
                    <div className="space-y-2">
                        <p><strong>Gender:</strong> {formData.gender || 'Not provided'}</p>
                        <p><strong>Marital Status:</strong> {formData.marital || 'Not provided'}</p>
                    </div>
                    <div className="space-y-2">
                        <p><strong>Education:</strong> {formData.education || 'Not provided'}</p>
                        <p><strong>Occupation:</strong> {formData.occupation || 'Not provided'}</p>
                    </div>
                    <div className="space-y-2">
                        <p><strong>Amount:</strong> Rs. 4,000</p>
                        {localData.father && <p><strong>Father:</strong> {localData.father}</p>}
                        {localData.mother && <p><strong>Mother:</strong> {localData.mother}</p>}
                    </div>
                </div>
            </div>
            
            <div className="flex justify-between pt-4">
                <button
                    type="button"
                    onClick={onPrevious}
                    disabled={loading}
                    className="btn-secondary flex items-center space-x-2"
                >
                    <FaArrowLeft />
                    <span>Previous</span>
                </button>
                <button
                    type="submit"
                    disabled={loading}
                    className="btn-primary flex items-center space-x-2"
                >
                    {loading ? (
                        <>
                            <div className="w-5 h-5 border-t-2 border-white rounded-full animate-spin"></div>
                            <span>Saving...</span>
                        </>
                    ) : (
                        <>
                            <FaHeart className="text-pink-200" />
                            <span>Next: Partner Preferences</span>
                            <span>→</span>
                        </>
                    )}
                </button>
            </div>
        </form>
    );
};

export default FamilyInformation;